





























import { computed, ComputedRef, defineComponent } from '@vue/composition-api';
import { useAllResources } from '@/store/modules/resources';
import { useAllSamplingCollections } from '@/store/modules/samplingCollections';
import { useAllSamplings } from '@/store/modules/samplings';
import { Field, LocationCollection, Sampling, SamplingCollection, SamplingCollectionStatus } from '@/store/types';
import { ORPHANED_DRAFT_SAMPLING_COLLECTION_INFO } from '../../constants';

export default defineComponent({
	props: {
		id: {
			required: true,
			type: String,
		},
	},
	setup(props, { root }) {
		const {
			isLoaded: resourcesAreLoaded,
			hasError: resourcesHaveError,
			samplingCollections: submittedSamplingCollections,
		} = useAllResources(root.$store);

		const {
			isLoaded: draftsAreLoaded,
			hasError: draftsHaveError,
			samplingCollections: draftSamplingCollections,
		} = useAllSamplingCollections(root.$store);

		const { isLoaded: samplingsAreLoaded, hasError: samplingsHaveError } = useAllSamplings(root.$store);

		const isLoaded = computed(() => resourcesAreLoaded.value && draftsAreLoaded.value && samplingsAreLoaded.value);

		const hasError = computed(() =>
			[draftsHaveError.value, samplingsHaveError.value, resourcesHaveError.value].some(Boolean)
		);

		const samplingCollectionStatus: ComputedRef<SamplingCollectionStatus> = computed(() =>
			root.$store.getters.getSamplingCollectionStatusBySamplingCollectionId(props.id)
		);

		const samplingCollection: ComputedRef<SamplingCollection | undefined> = computed(
			() =>
				submittedSamplingCollections.value?.find(({ id }: SamplingCollection) => id === props.id) ||
				draftSamplingCollections.value?.find(({ id }: SamplingCollection) => id === props.id)
		);

		const field: ComputedRef<Field | undefined> = computed(() =>
			root.$store.getters['resources/getFieldById'](samplingCollection.value?.featureOfInterest)
		);

		const samplings: ComputedRef<Sampling[]> = computed(() => {
			if (samplingCollectionStatus.value === 'SUBMITTED') {
				return root.$store.getters['resources/getSamplingsBySamplingCollectionId'](props.id);
			}
			if (samplingCollectionStatus.value === 'DRAFT') {
				return root.$store.getters['samplings/getBySamplingCollectionId'](props.id);
			}
			return [];
		});

		const locationCollection: ComputedRef<LocationCollection | undefined> = computed(() =>
			root.$store.getters['resources/getLocationCollectionById'](samplingCollection.value?.object)
		);

		const locationsCount: ComputedRef<number> = computed(() => locationCollection.value?.features?.length ?? 0);

		const progressText: ComputedRef<string> = computed(() =>
			isLoaded.value
				? locationCollection.value
					? `${samplings.value.length} / ${locationsCount.value}`
					: `${samplings.value.length}`
				: ''
		);

		return {
			samplingCollection,
			field,
			progressText,
			isLoaded,
			hasError,
			locationCollection,
			ORPHANED_DRAFT_SAMPLING_COLLECTION_INFO,
		};
	},
});
